import { LoginPage } from '@/features/auth';

/**
 * Login UI shown by the bootstrap layer when Firebase has resolved and there is
 * no signed-in user. Wraps `features/auth` so `app/` never imports `features/` directly.
 */
export function UnauthenticatedFallback() {
    return <LoginPage onLoginSuccess={() => {}} />;
}
